module.exports = __webpack_public_path__ + "img/what-is-banner.79cc9d33.png";